import { ISettings } from '../interfaces/ISettings';

import { setupApi } from './api';

export async function loadWhiteLabelSettings(
  domain: string
): Promise<ISettings> {
  try {
    const { data } = await setupApi().get<ISettings>('/resales/domain', {
      params: {
        domain,
      },
    });

    return data;
  } catch {
    return null;
  }
}
